/* eslint-disable no-inline-comments */
/* eslint-disable consistent-return */
/* eslint-disable no-undefined */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import { hideLoader, showLoader } from '../store/actions/loaderActions'
import {
  SHOW_TOAST,
  SHOW_LOADER,
  HIDE_LOADER,
  VALUES_NAME,
  ACCESS_COMPETENCIES,
  SIMPLE_VALUES,
  FB_URL
} from '../store/actions/types'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {
  createTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles'
import {
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  Paper,
  Button,
  Avatar,
  Card,
  List,
  ListItemText,
  ListItem,
  ListItemSecondaryAction,
  ListItemIcon,
  Menu,
  MenuItem
} from '@material-ui/core'
import { green, orange, red } from '@material-ui/core/colors'
import CheckIcon from '@material-ui/icons/Check'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import GroupWorkIcon from '@material-ui/icons/GroupWork'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import DescriptionIcon from '@material-ui/icons/Description'
import TextsmsIcon from '@material-ui/icons/Textsms'
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import FilterListIcon from '@material-ui/icons/FilterList'
import { lighten } from '@material-ui/core/styles/colorManipulator'
import grey from '@material-ui/core/colors/grey'
import AddCorpUserDialog from './../components/Dialogs/AddCorpUserDialog'
import GroupAdminDialog from './../components/Dialogs/GroupAdmin/GroupAdminDialog'
import GroupEditAdminDialog from './../components/Dialogs/GroupAdmin/GroupEditAdminDialog'
import UserTypeDialog from './../components/Dialogs/UserTypeDialog'
import ChangeUserPasswordDialog from './../components/Dialogs/ChangeUserPasswordDialog'
import { LIGHTGREY, LIGHTBLUE } from '../utils/color_utils'
import CardContent from '@material-ui/core/CardContent'
import { PHOTO_PROFILE } from '../utils/photo_utils'
import { connect } from 'react-redux'
import {
  getAllCompanyUsers,
  deleteCompanyUser,
  resetYCompanyUser,
  createCompanyUser,
  updateCompanyUser,
  resendWelcomeEmail,
  changeUserType,
  checkUserExists,
  getAllCompanySettings,
  getAllGeneralSettings,
  editUser,
  checkUserExistsEdit
} from './../store/actions/companyAdminActions'
//TEST GITHUB CONNECTION
// [NEED TO BE FIX] need to fix as per need
import * as XLSX from 'xlsx'
import firebase from '../store/firebase'
import { showToast } from './../store/actions/toastAction'
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact'
import TextField from '@material-ui/core/TextField'
import LeaderLoader from './LeaderLoader'
import { simpleAction } from './../store/actions/simpleAction'
import  GotoPersonPledge from './GotoPersonPledge'
import axios from 'axios';
import CryptoJS from "crypto-js";
import LanguageIcon from '@material-ui/icons/Language'

const MOBILE_DEFAULT_COLUMNS = new Set(['Firstname', 'Lastname', 'Email', 'Lc', 'EC', 'Last Pledge Date'])
const MOBILE_COLUMN_WIDTHS = {
  'Firstname': '16%',
  'Lastname': '16%',
  'Email': '22%',
  'Lc': '10%',
  'EC': '10%',
  'Last Pledge Date': '20%'
}
const MOBILE_COL_PX = {
  'Firstname': 62,
  'Lastname': 56,
  'Email': 104,
  'Lc': 30,
  'EC': 28,
  'Last Pledge Date': 66
}

const truncatedCellStyle = (px, bold) => ({
  display: 'block',
  width: px ? `${px}px` : '100%',
  maxWidth: px ? `${px}px` : '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: bold ? 'bold' : 'normal'
})

// Inline toggle component for AI Lead Filter (company-level)
const AILeadFilterToggle = ({ userdata }) => {
  const [enabled, setEnabled] = React.useState(true)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (!userdata || !userdata.companyID) return
    const ref = firebase.database.ref(`company-settings/${userdata.companyID}/lead_ai_filter_enabled`)
    const unsub = ref.on('value', (snap) => {
      if (snap.exists()) {
        setEnabled(!!snap.val())
      } else {
        // if no company override, read global default; if missing, default true
        firebase.database
          .ref('content-settings/lead_ai_filter_enabled')
          .once('value')
          .then((gs) => setEnabled(gs.exists() ? !!gs.val() : true))
          .catch(() => setEnabled(true))
      }
    })
    return () => ref.off('value', unsub)
  }, [userdata])

  const toggle = async () => {
    if (!userdata || !userdata.companyID) return
    try {
      setLoading(true)
      const ref = firebase.database.ref(`company-settings/${userdata.companyID}/lead_ai_filter_enabled`)
      await ref.set(!enabled)
      setEnabled(!enabled)
    } catch (e) {
      // fail silent
    } finally {
      setLoading(false)
    }
  }

  return (
   (userdata.userType === 21 ? null :
    <Button
      variant='outlined'
      color={enabled ? 'primary' : 'default'}
      size='small'
      onClick={toggle}
      disabled={loading}
      title='Toggle AI content filter for leads (company override)'
    >
      {`AI Filter: ${enabled ? 'On' : 'Off'}`}
    </Button>
  )
  )
}

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
    boxShadow: 'none'
  },
  highlight: theme.palette.type === 'light' ? {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.85)
  } : {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.dark
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: '0 0 auto'
  },
  button: {
    'margin': theme.spacing.unit,
    'color': '#ffffff',
    'backgroundColor': `${LIGHTBLUE}`,
    '&:hover': {
      backgroundColor: `${LIGHTBLUE}`,
      color: '#ffffff'
    },
    'fontSize': '10px'
  },
  deleteButton: {
    backgroundColor: red[400],
    color: '#ffffff',
    margin: theme.spacing.unit,
    fontSize: '10px'
  },
  activeButton: {
    backgroundColor: orange[800],
    color: '#ffffff',
    margin: theme.spacing.unit,
    fontSize: '10px'
  },
  userTypeButton: {
    backgroundColor: green[400],
    color: '#ffffff',
    margin: theme.spacing.unit,
    fontSize: '10px'
  },

  settingsIcons: {
    margin: theme.spacing.unit
  },
  icon: {
    fontSize: '20px'
  }
})

const table = {
  color: 'red',
  fontSize: 8,
  border: '1px solid grey'
}

let EnhancedTableToolbar = props => {
  const {
    numSelected,
    classes,
    multiple,
    onDeleteUser,
    onResetYUser,
    onActivateLc,
    onDActivateLc,
    confirmPatron,
    confirmFlex,
    giveLc,
    onChangeUserData,
    onOpenUpdateUserDialog,
    onResendWelcomeEmail,
    onOpenChangePassword,
    onOpenUserTypeDialog,
    handleEditUserDialog
  } = props

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
      elevation={0}
    >
      <div className={classes.title} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <React.Fragment>
            {numSelected === 1 ? (
              <React.Fragment>
                <Button
                  variant='contained'
                  aria-label='Edit'
                  onClick={handleEditUserDialog}
                  className={classes.userTypeButton}
                  size='small'
                >
                  <EditIcon className={classes.icon} />
                  Edit
                </Button>
                <Button
                  variant='contained'
                  aria-label='Delete'
                  onClick={onOpenUserTypeDialog}
                  className={classes.userTypeButton}
                  size='small'
                >
                  <EditIcon className={classes.icon} />
                  Change User type
                </Button>
                <Button
                  variant='contained'
                  onClick={onResendWelcomeEmail}
                  className={classes.button}
                  aria-label='Delete'
                  size='small'
                >
                  <MarkunreadMailboxIcon className={classes.icon} />
                  Resend Welcome Email
                </Button>

                <Button
                  onClick={onOpenChangePassword}
                  variant='contained'
                  className={classes.button}
                  aria-label='Change Password'
                  size='small'
                >
                  <TextsmsIcon className={classes.icon} />
                  Change Password
                </Button>
                <Button
                  onClick={() => onChangeUserData('changeActiveStatus')}
                  variant='contained'
                  aria-label='Delete'
                  className={classes.activeButton}
                  size='small'
                >
                  <CheckIcon className={classes.icon} />
                  Activate / Deactivate
                </Button>
              </React.Fragment>
            ) : null}
            {props.userType === 14 ? null :
            (<div>
             <Button
                onClick={onDeleteUser}
                variant='contained'
                className={classes.deleteButton}
                aria-label='Delete'
                size='small'
              >
                <DeleteIcon />
                {multiple ? `Delete (${numSelected})` : 'Delete'}
              </Button>
            
              <Button
                onClick={onResetYUser}
                variant='contained'
                className={classes.activeButton}
                aria-label='Reset Annual Points'
                size='small'
              >
                <DeleteIcon />
                {multiple ? `Reset Annual Points for (${numSelected})` : 'Reset Annual Points'}
              </Button>

              <Button
                onClick={onActivateLc}
                variant='contained'
                className={classes.activeButton}
                aria-label='Activate Lc'
                size='small'
              >
                <EditIcon className={classes.icon} />
                {multiple ? `Activate Lc for (${numSelected})` : 'Activate Lc'}
              </Button>   

               <Button
                onClick={onDActivateLc}
                variant='contained'
                className={classes.activeButton}
                aria-label='De-Activate Lc'
                size='small'
              >
                <EditIcon className={classes.icon} />
                {multiple ? `De-Activate Lc for (${numSelected})` : 'De-Activate Lc'}
              </Button>  

              <Button
                onClick={confirmPatron}
                variant='contained'
                className={classes.activeButton}
                aria-label='Confirm Pledge'
                size='small'
              >
                <EditIcon className={classes.icon} />
                {multiple ? `Confirm pledge for (${numSelected})` : 'Confirm Pledge'}
              </Button>    


              <Button
                onClick={confirmFlex}
                variant='contained'
                className={classes.activeButton}
                aria-label='Confirm Pledge'
                size='small'
              >
                <EditIcon className={classes.icon} />
                {multiple ? `Confirm Flex pledge for (${numSelected})` : 'Confirm Flex Pledge'}
              </Button>  

             <Button
                onClick={giveLc}
                variant='contained'
                className={classes.activeButton}
                aria-label='Confirm Pledge'
                size='small'
              >
                <EditIcon className={classes.icon} />
                {multiple ? `Give Lc/Pledge to (${numSelected})` : 'Give Lc/Pledge to '}
              </Button>          
              </div>)
            }
          </React.Fragment>
        ) : (
          <Tooltip title='Filter list'>
            <IconButton aria-label='Filter list'>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired
}

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar)

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {
    minWidth: '700',
    minWidth: 650,
    size: 'small',
    ariaLabel: 'a dense table'
  },
  tableRow: {
    height: 30
  },
  tableCell: {
    padding: "0px 16px"
  },
  btn: {
    margin: theme.spacing.unit
  },
  button: {
    'margin': theme.spacing.unit,
    'backgroundColor': '#0288d1',
    '&:hover': {
      backgroundColor: '#0288d1'
    }
  },
  button2: {
    'margin': theme.spacing.unit,
    'backgroundColor': '#0288d1',
    '&:hover': {
      backgroundColor: '#0288d1'
    },
    'height': '50px',
    'width': '15%'
  },
  pageHeader: {
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: '120px'
    }
  },
  paperHeader: {
    backgroundColor: grey[300]
  },
  activate: {
    color: green[800],
    textAlign: 'center'
  },
  deactivate: {
    color: red[400],
    textAlign: 'center'
  },
  card: {
    width: 500
  }
})

const UserCardList = props => {
  const { classes } = props
  return (
    <Card className={classes.card}>
      <CardContent>
        <Avatar>{props.user[1][0]}</Avatar>
        <List>
          <ListItem>
            <ListItemText
              primary={<Typography variant='caption'>First Name</Typography>}
            />
            <ListItemSecondaryAction>
              <Typography variant='body2'>{props.user[1]}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<Typography variant='caption'>Last Name</Typography>}
            />
            <ListItemSecondaryAction>
              <Typography variant='body2'>{props.user[2]}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<Typography variant='caption'>Email</Typography>}
            />
            <ListItemSecondaryAction>
              <Typography variant='body2'>{props.user[3]}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<Typography variant='caption'>User type</Typography>}
            />
            <ListItemSecondaryAction>
              <Typography variant='body2'>{props.user[4]}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<Typography variant='caption'>Status</Typography>}
            />
            <ListItemSecondaryAction>
              <Typography variant='body2'>{props.user[5]}</Typography>
              {/* <RadioButtonCheckedIcon className={classes.activate} /> */}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  )
}

const CopyableCell = ({ value, displayText, onCopied }) => {
  if (!value) return null

  const handleCopy = async (e) => {
    e.stopPropagation()
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = value
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }
      if (onCopied) onCopied(value)
    } catch (err) {
      // fail silent
    }
  }

  return (
    <Tooltip title={value}>
      <span
        onClick={handleCopy}
        style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
        title='Click to copy'
      >
        {displayText}
      </span>
    </Tooltip>
  )
}

class CompanyAdmin extends Component {
  constructor(props) {
    super(props)
    //    // this.handleSelectedUserType = this.handleSelectedUserType.bind(this);

    // this.state = {
    //   data: [],
    //   openGroupAdminDialog: false,
    //   openGroupEditAdminDialog: false,
    //   openDialog: false,
    //   openUploadDialog: false,
    //   openPasswordChange: false,
    //   openUserType: false,
    //   selectedRowData: {},
    //   selectedUserType: "",
    //   selectedFile: null,
    //   showFdelete: false,
    //   selectDelete: 0,
    //   profilesDelete: {},
    //   anchorEl: null,
    //   edit: false,
    //   editedUser: {},
    //   uploading: false
    // };

    // this.onChangeHandler = this.onChangeHandler.bind(this);

    // Mobile double-tap sort: inject custom cell renderers for visible columns (skip Avatar)
    try {
      if (typeof window !== 'undefined' && window.innerWidth <= 768 && Array.isArray(this.columns)) {
        this.columns = this.columns.map((col, idx) => {
          if (!col || col.name === 'Avatar') return col
          const opts = col.options || {}
          return {
            ...col,
            options: {
              ...opts,
              // Keep existing renderer if present; otherwise add mobile double-tap sort wrapper
              customBodyRender: opts.customBodyRender || this.createMobileSortableRenderer()
            }
          }
        })
      }
    } catch (e) {
      // Fail-safe: do nothing if any error occurs while enhancing mobile behavior
    }
  }

  // Track last tap to detect double-tap on touch devices
  lastTapTime = 0
  lastTapColumnIndex = -1

  isMobile = () => (typeof window !== 'undefined' && window.innerWidth <= 768)

  createMobileSortableRenderer = () => (value, tableMeta) => {
    if (!this.isMobile() || !tableMeta) return value

    const onDoubleActivate = () => {
      if (typeof tableMeta.columnIndex === 'number') {
        this.handleMobileSortByIndex(tableMeta.columnIndex)
      }
    }

    const onTouchEnd = () => {
      const now = Date.now()
      if (this.lastTapColumnIndex === tableMeta.columnIndex && now - this.lastTapTime < 350) {
        onDoubleActivate()
      }
      this.lastTapTime = now
      this.lastTapColumnIndex = tableMeta.columnIndex
    }

    return (
      <span onDoubleClick={onDoubleActivate} onTouchEnd={onTouchEnd} style={{ display: 'inline-block', width: '100%' }}>
        {value}
      </span>
    )
  }

  handleMobileSortByIndex = (columnIndex) => {
    if (!this.isMobile()) return
    const prev = this.state.mobileSort
    let order = 'desc'
    if (prev && prev.columnIndex === columnIndex) {
      order = prev.order === 'desc' ? 'asc' : 'desc'
    }
    const colName = (this.columns && this.columns[columnIndex] && this.columns[columnIndex].name) || ''
    this.setState({ mobileSort: { columnIndex, colName, order } })
  }

getMuiTheme = () => {
  const mobile = this.isMobile()
  return createTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: '#FF000'
        },
        paper: {
          boxShadow: 'none'
        },
        responsiveScroll: {
          marginTop: mobile ? '10px' : '50px'
        }
      },
    MUIDataTableHeadCell: {
      root: {
        padding: mobile ? '1px 2px' : '0px',
        verticalAlign: 'top!important'
      },
      head: {
        fontSize: mobile ? '0.5rem' : '0.7rem',
        fontWeight: mobile ? 'bold' : '500',
        padding: mobile ? '1px 2px' : '0px',
        verticalAlign: 'textTop',
        lineHeight: mobile ? '1.1' : 'normal'
      }
    },
    MUIDataTableBodyCell: {
      root: {
        borderBottom: '0px',
        fontSize: mobile ? '0.62rem!important' : '0.70rem!important',
        padding: mobile ? '1px 2px' : '0px 1px 0px 0px',
        lineHeight: mobile ? '1.1' : 'normal'
      }
    },
    MUIDataTableSelectCell: {
      root: {
        borderBottom: '0px',
        padding: mobile ? '0px' : undefined,
        width: mobile ? '30px' : undefined,
        minWidth: mobile ? '30px' : undefined,
        maxWidth: mobile ? '30px' : undefined,
        boxSizing: mobile ? 'border-box' : undefined
      }
    },
      MUIDataTableToolbarSelect: {
        root: {
          display: 'inlineBlock'
        }
      },
      MuiTable: {
      root: {
        tableLayout: mobile ? 'fixed' : 'auto',
        width: '100%'
      }
    },
    MuiTablePagination: {
  root: {
    width: mobile ? '100%' : 'auto'
  },
  toolbar: {
    paddingLeft: mobile ? '4px' : undefined,
    paddingRight: mobile ? '4px' : undefined,
    flexWrap: mobile ? 'wrap' : 'nowrap',
    minHeight: mobile ? '40px' : undefined
  },
  selectRoot: {
    marginRight: mobile ? '4px' : undefined
  },
  caption: {
    fontSize: mobile ? '0.65rem' : undefined
  },
  input: {
    fontSize: mobile ? '0.65rem' : undefined
  },
  actions: {
    marginLeft: mobile ? '0px' : undefined
  }
}
    }
  })
}

columns = [{
  name: 'Avatar',
  options: {
    filter: false,
    display: true
  }
},
{
  name: 'Firstname',
  options: {
    filter: true,
    display: true
  }
},
{
  name: 'Lastname',
  options: {
    filter: true,
    display: true
  }
},
{
  name: 'Country',
  options: {
    filter: true,
    display: false,
    hint: 'User nationality/country'
  }
},
{
  name: 'Email',
  options: {
    filter: true,
    display: true
  }
},
{
  name: 'User Type',
  options: {
    filter: true,
    display: false
  }
},
{
  name: 'Lc',
  options: {
    filter: true,
    display: true
  }
},
{
  name: 'Sector',
  options: {
    filter: true,
    display: false
  }
},
{
  name: 'Position',
  options: {
    filter: true,
    display: false
  }
},
{
  name: 'DateRegistered',
  options: {
    filter: false,
    display: false
  }
},
{
  name: 'EC',
  options: {
    filter: false,
    display: true
  }
},
{
  name: 'Feedback',
  options: {
    filter: false,
    display: false
  }
},
{
  name: 'Wallet',
  options: {
    filter: false,
    display: true
  }
},
{
  name: 'Last Pledge Date',
  options: {
    filter: false,
    display: true
  }
},
{
  name: 'MEV',
  options: {
    filter: false,
    display: true
  }
},
{
  name: 'Last Pledge Type',
  options: {
    filter: true,
    display: false
  }
},
];

  options = {
    filterType: 'radio',
    sort: true,
    rowHover: true,
    responsive: 'standard', // was 'vertical' — keeps table format instead of stacking on mobile
    print: false,
    download: false,
    selectableRows: 'multiple',
    fixedHeader: false,
    tableHeaderStyle: { borderRight: '40px solid transparent' },
    onFilterChange: (changedColumn, filterList) => {
    },
    // expandableRows: true,
    // renderExpandableRow: (rowData, rowMeta) => <UserCardList user={rowData} {...this.props} />,

    customToolbarSelect: e => {

      return (
        <EnhancedTableToolbar
          userType={this.props.userdata.userType}
          numSelected={e.data.length}
          multiple={e.data.length > 0}
          options={{
            elevation: 0
          }}
          onOpenChangePassword={this.handleOpenChangePassword}
          onOpenUserTypeDialog={this.handleUserTypeDialog}
          handleEditUserDialog={this.handleEditUserDialog}
          onResendWelcomeEmail={() =>
            this.handleResendWelcomeEmail(this.props.resendWelcomeEmail)
          }
          onChangeUserData={changeType => this.handleChangeUserData(changeType)}
          onDeleteUser={() =>
            e.data.length === 1 ?
              this.handleDeleteUser()
              :
              this.handleBulkDeleteUser(this.props.deleteCompanyUser, e.data.length)
          }
          onActivateLc={() =>
            e.data.length === 1 ?
              this.ActivateUserLc()
              :
              this.handleBulkLc(e.data.length)
          }
         onDActivateLc={() =>
            e.data.length === 1 ?
              this.DActivateUserLc()
              :
              this.DhandleBulkLc(e.data.length)
          }
          confirmPatron={() =>
            e.data.length === 1 ?
              this.confirmUserPledge()
              :
              this.handleBulkPledge(e.data.length)
            // console.log('bulk pledge confirm done here')
          }

          confirmFlex={() =>
            e.data.length === 1 ?
              this.confirmFlexPledge()
              :
             // this.handleBulkPledge(e.data.length)
             console.log('Flex pledge confirm done here')
          }

          giveLc={() =>
            e.data.length === 1 ?
              this.giveLcto()
              :
              this.PledgeByProxy()
          }

          onResetYUser={() =>
            e.data.length === 1 ?
              this.handleResetYUser()
              :
              this.handleResetBulkUsers(this.props.resetYCompanyUser, e.data.length)
          }
        />
      )
    },
    onRowsSelect: (currentRowsSelected, allRowsSelected) => {
      let { classes, userdata, users } = this.props

      let data =
        users &&
        Object.keys(users).map((v, i) => {
          return { data: users[v], uid: users[v].id }
        })
      // ............................................
      let selectedData =
        allRowsSelected &&
        Object.keys(allRowsSelected).map((v, i) => {
          //  return { data: allRowsSelected[v], uid: allRowsSelected[v].dataIndex }
          //  return { data: data[allRowsSelected[v].dataIndex], uid: allRowsSelected[v].dataIndex }
          return { data: users[allRowsSelected[v].dataIndex], uid: allRowsSelected[v].dataIndex }
        })
      // ............................................

      if (allRowsSelected.length === 1) {
        if (currentRowsSelected[0] !== undefined) {
          window.su = data[currentRowsSelected[0].dataIndex]
          this.handleSelectedUser(window.su)
        }
      } else {
        window.su = selectedData
      }
    },
    textLabels: {
      body: {
        noMatch: ''
      }
    }
  };

  state = {
    data: [],
    openGroupAdminDialog: false,
    openGroupEditAdminDialog: false,
    openDialog: false,
    openUploadDialog: false,
    openPasswordChange: false,
    openUserType: false,
    selectedRowData: {},
    selectedUserType: '',
    selectedFile: null,
    showFdelete: false,
    selectDelete: 0,
    profilesDelete: {},
    anchorEl: null,
    edit: false,
    editedUser: {},
    uploading: false,
    LCPOOLValue: 0,
    cachedUsers: null,
    mobileSort: null,
    visibleColumns: {},
    tableData: [], 
  };

  // localStorage methods for caching users data
  saveUsersToCache = (users) => {
    try {
      const cacheKey = `companyUsers_${this.props.userdata?.companyID || 'default'}`
      const cacheData = {
        users,
        timestamp: Date.now(),
        companyID: this.props.userdata?.companyID
      }
      localStorage.setItem(cacheKey, JSON.stringify(cacheData))
      } catch (error) {
      }
  }

  loadUsersFromCache = () => {
    try {
      const cacheKey = `companyUsers_${this.props.userdata?.companyID || 'default'}`
      const cachedData = localStorage.getItem(cacheKey)
      
      if (cachedData) {
        const parsedData = JSON.parse(cachedData)
        const cacheAge = Date.now() - parsedData.timestamp
        const maxCacheAge = 5 * 60 * 1000 // 5 minutes
        
        // Check if cache is still valid and for the same company
        if (cacheAge < maxCacheAge && parsedData.companyID === this.props.userdata?.companyID) {
          return parsedData.users
        } else {
          localStorage.removeItem(cacheKey)
        }
      }
    } catch (error) {
      }
    return null
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: !this.state.openDialog })
  };

  handleUserTypeDialog = () => {
    this.setState({
      openUserType: !this.state.openUserType,
      selectedUserType: window.su.data.userDescription
    })
  };
  handleOpenChangePassword = () => {
    this.setState({
      openPasswordChange: !this.state.openPasswordChange
    })
  };

  handleSelectedUserType = userTypeSelected => {
    const { changeUserType, userdata } = this.props
    let user = window.su.data
    user.uid = window.su.uid
    let params = {
      usersData: user,
      currentloggedinuser: userdata,
      selectedUserType: userTypeSelected
    }
    changeUserType(params)
    this.handleUserTypeDialog()
  };
  
  handleUploadDialog = () => {
    this.setState({ openUploadDialog: !this.state.openUploadDialog })
  };
  handleChangeUserData = changeType => {
    const { updateCompanyUser, getAllCompanyUsers, userdata } = this.props
    let userProfile = window.su.data
    userProfile.uid = window.su.uid
    let params = {
      changeType: changeType,
      userProfile: userProfile
    }
    updateCompanyUser(params)
    getAllCompanyUsers({
      companyID: userdata.companyID,
      orderChild: 'companyID'
    })
  };

  handleResendWelcomeEmail = resendWelcomeEmail => {
    let user = window.su
    resendWelcomeEmail({
      userProfile: { uid: user.uid, ...user.data }
    })
  };

  componentWillUnmount() {
    window.su = null
  }

  handleSelectedUser = currentRowsSelected => {
    // this.setState({
    //  selectedRowData: {
    //    uid: rowUserData[5].props.id,
    //    userID: rowUserData[5].key,
    //    firstName: rowUserData[1],
    //    lastName: rowUserData[2],
    //    email: rowUserData[3],
    //    userType: rowUserData[4]
    //  }
    // });
  };

  handleSubmitUser = userData => {
    let params = {
      email: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
      companyID: this.props.userdata.companyID,
      companyName: this.props.userdata.companyName,
      userType: userData.usertype,
      selectedCategory: userData.usertype,
      surName: userData.surName,
      gender: userData.gender,
      //wallet: userData.wallet,
      points: userData.points,
      addpoints: userData.addpoints,
      race: userData.race,
      position: userData.position,
      nationality: userData.nationality,
      idNumber: userData.idNumber,
      cellphone: userData.cellphone,
      department: userData.department,
      operation: userData.operation,
      edit: userData.edit,
      uid: userData.uid,
      userID: userData.userID,
      feedback: userData.feedback,
      feedbackOn: userData.feedbackOn ? userData.feedbackOn : true,
      demoOn: userData.demoOn ? userData.demoOn : false,
      LeaderboardKey: this.props.userdata.companyID + '_' + userData.nationality + '_' + userData.position + '_' + userData.department
    }
    // check if user exists
    // this.props.createCompanyUser(params)
    if (userData.edit === false) {
      this.props.checkUserExists(params, () => {
        this.props.createCompanyUser(params)
        this.props.getAllCompanyUsers({
          companyID: this.props.userdata.companyID,
          orderChild: 'companyID'
        })
      }, () => {
        this.handleCloseDialog()
      })
    } else {
      // this.props.editUser(params)
      this.props.checkUserExistsEdit(params) // USE THIS PROCESS ONCE USERS CAN BE RE-AUTHENTICATED AFTER EMAIL CHANGE
      this.props.editUser(params)
      this.props.getAllCompanyUsers({
        companyID: this.props.userdata.companyID,
        orderChild: 'companyID'
      })
      this.handleCloseDialog()
    }
  };

  //componentDidUpdate(prevProps) {
  componentDidUpdate(prevProps, prevState) {  
    // Check if userdata became available and we haven't loaded users yet
    if (
      (!prevProps.userdata || !prevProps.userdata.companyID) &&
      this.props.userdata && 
      this.props.userdata.companyID &&
      (!this.props.users || Object.keys(this.props.users).length === 0)
    ) {
      this.props.getAllCompanyUsers({
        companyID: this.props.userdata.companyID,
        orderChild: 'companyID'
      })
      this.props.getAllCompanySettings({
        companyID: this.props.userdata.companyID
      })
      this.props.getAllGeneralSettings({
        companyID: this.props.userdata.companyID
      })
    }

    // Save users to cache when they become available
    if (
      this.props.users && 
      Object.keys(this.props.users).length > 0 &&
      (!prevProps.users || Object.keys(prevProps.users).length === 0)
    ) {
      this.saveUsersToCache(this.props.users)
    }

  // ──────────────────────────────────────────────────────────────
  // NEW: Keep tableData stable so selection doesn't reset on re-renders
  // ──────────────────────────────────────────────────────────────
  const usersChanged = this.props.users !== prevProps.users;
  const cacheChanged = this.state.cachedUsers !== prevState?.cachedUsers;

  if (usersChanged || cacheChanged) {
    const newTableData = this.transformTableData();
    this.setState({ tableData: newTableData });
  }
 }

  // //////GET LCPOOL////////////////////////////////////////////////////
  // async getLCPOOLValue() {
  //   try {
  //     const snapshot = await firebase.database
  //     .ref('patreon/').once('value');
  //     const LCPOOLValue = snapshot.val();
  //     return LCPOOLValue;
  //   } catch (error) {
  //     return null;
  //   }
  // };
  // //////////////////////////////////////////////////////////////////////////

  componentDidMount() {
    let { classes, userdata, getAllCompanyUsers, getAllCompanySettings, getAllGeneralSettings, users, simpleAction } = this.props
    
    // Try to load users from localStorage if not available in props
    if (!users || Object.keys(users).length === 0) {
      const cachedUsers = this.loadUsersFromCache()
      if (cachedUsers && Object.keys(cachedUsers).length > 0) {
        // You would need to dispatch an action to update Redux store
        // For now, we'll set it in component state as fallback
        this.setState({ cachedUsers })
      }
    }
    
    // Check if userdata and companyID exist before making API calls
    if (userdata && userdata.companyID) {
      getAllCompanyUsers({
        companyID: userdata.companyID,
        orderChild: 'companyID'
      })
      getAllCompanySettings({
        companyID: userdata.companyID
      })
      getAllGeneralSettings({
        companyID: userdata.companyID
      })
    } else {
      }
    
    let body = {
      type: SIMPLE_VALUES,
      surveyid: false
    }
    simpleAction(body)

    this.getLCPOOLValue()

    //this.getTotalMevInWallet()
  }

// ──────────────────────────────
//  decryptUID 
// ──────────────────────────────
decryptUID(cipherText) {
  const AES_KEY = "4f9c1fa7ec2f4832973c0f5d2f43b7cc";
  const AES_IV  = "7f4d3b92c3a04f8dac5c59cbf1a4d87f";

  // Fix: Convert URL-safe Base64 → standard Base64
  cipherText = cipherText.replace(/-/g, '+').replace(/_/g, '/');

  const key = CryptoJS.enc.Hex.parse(AES_KEY);
  const iv  = CryptoJS.enc.Hex.parse(AES_IV);

  const cipherParams = {
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  };

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

/////////////////////////////////////////////////////////////////////////////////////

  formatUserList(param) {
    const temp = []
    param.map((user) => {
      temp.push({
        firstName: user[2],
        lastName: user[3],
        email: user[4],
        userType: user[5],
        gender: user[6],
        department: user[7],
        operation: user[8],
        position: user[9],
        nationality: user[10],
        uid: user[11],
        userID: user[12],
        stringDateRegistered: user[13],
        selected: false,
        visible: '',
        execmember: user[15],
        feedback: user[16], 
        wallet: user[17]
      })
    })

    return temp
  }

  timeConverter = (UNIX_timestamp) => {
    let a = new Date(UNIX_timestamp)
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let year = a.getFullYear()
    // var month = months[a.getMonth()];
    let month = a.getMonth()
    month = month + 1

    let date = a.getDate()
    let vdate = date.toString()
    let vmonth = month.toString()
    let vvdate
    let vvmonth
    // ///////////////////
    if (vdate.length === 1) {
      var s = '0' + date
      vvdate = s.substr(s.length - 2)
    } else {
      vvdate = vdate
    }
    // /////////////////////////
    if (vmonth.length === 1) {
      var s = '0' + month
      vvmonth = s.substr(s.length - 2)
    } else {
      vvmonth = month
    }
    // //////////////////
    // vdate = (Math.round(date * 100) / 100).toFixed(2);
    let hour = a.getHours()
    let min = a.getMinutes()
    let sec = a.getSeconds()
    // var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    let time = year + '/' + vvmonth + '/' + vvdate
    return time
  }

// Renders a truncated wallet address with full value on hover
renderWallet = (wallet) => {
  if (!wallet) return null
  const short = wallet.length > 10 ? `${wallet.substring(0, 10)}...` : wallet
  return (
    <CopyableCell
      value={wallet}
      displayText={short}
      onCopied={() => this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'Wallet address copied!'
      })}
    />
  )
}

renderEmail = (email) => {
  if (!email) return ''
  return (
    <CopyableCell
      value={email}
      displayText={email}
      onCopied={() => this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'Email address copied!'
      })}
    />
  )
}

// Formats lastPledgeDate / lastPledgeType, defaulting to 'none' when empty
formatPledgeValue = (val, isDate) => {
  if (val === undefined || val === null || val === '') {
    return 'none'
  }
  if (isDate) {
    const num = Number(val)
    if (!isNaN(num) && num > 0) {
      try {
        return this.timeConverter(num)
      } catch (e) {
        return String(val)
      }
    }
  }
  return String(val)
}

  transformTableData = () => {
    let { classes, userdata, getAllCompanyUsers, users } = this.props
    

    // Use cached users if Redux store is empty
    const usersData = users && Object.keys(users).length > 0 ? users : this.state.cachedUsers

    // Check if users data exists before processing
    if (!usersData || Object.keys(usersData).length === 0) {
      return []
    }

    let dataListClone = Object.keys(usersData).map((uid, index) => {
      let ds = usersData[uid].dateRegistered
      // var date = new Date(ds);
      // var hours = date.getHours();
      // var ddds = hours // d.getMonth();
      let ddds = this.timeConverter(ds)
      return [
        <Avatar
          alt={usersData[uid].firstName + ' ' + usersData[uid].lastName}
          src={PHOTO_PROFILE(usersData[uid].photoURL)}
          id={usersData[uid].uid}
        />,

        usersData[uid].firstName ? usersData[uid].firstName : '',
        usersData[uid].lastName ? usersData[uid].lastName : '',
        usersData[uid].nationality ? usersData[uid].nationality : '', // Country at position 3
        this.renderEmail(usersData[uid].email), // Email at position 4
        usersData[uid].userDescription, // User Type at position 5
        usersData[uid].points ? Math.round(Number(usersData[uid].points) / 10) / 10 : '', // numeric Lc at position 6 (1 decimal)
        usersData[uid].department ? usersData[uid].department : '', // Sector at position 7
        usersData[uid].position ? usersData[uid].position : '', // Position at position 8

        ddds ? ddds : '',
        usersData[uid].execmember ? 'Y' : 'N',
        usersData[uid].feedback ? usersData[uid].feedback : 'N',
        this.renderWallet(usersData[uid].wallet),
        this.formatPledgeValue(usersData[uid].lastPledgeDate, true),
        usersData[uid].mevInWallet !== undefined && usersData[uid].mevInWallet !== null && usersData[uid].mevInWallet !== ''
          ? Number(usersData[uid].mevInWallet).toFixed(2)
          : '',
        this.formatPledgeValue(usersData[uid].lastPledgeType, false),
        usersData[uid].uid ? usersData[uid].uid : '',
        usersData[uid].userID ? usersData[uid].userID : ''
      ]
    })

    return dataListClone
  };

  // transformTableData_BAK = () => {
  //   let { classes, userdata, getAllCompanyUsers, users } = this.props
    

  //   // Use cached users if Redux store is empty
  //   const usersData = users && Object.keys(users).length > 0 ? users : this.state.cachedUsers

  //   // Check if users data exists before processing
  //   if (!usersData || Object.keys(usersData).length === 0) {
  //     return []
  //   }

  //   let dataListClone = Object.keys(usersData).map((uid, index) => {
  //     let ds = usersData[uid].dateRegistered
  //     // var date = new Date(ds);
  //     // var hours = date.getHours();
  //     // var ddds = hours // d.getMonth();
  //     let ddds = this.timeConverter(ds)
  //     return [
  //       <Avatar
  //         alt={usersData[uid].firstName + ' ' + usersData[uid].lastName}
  //         src={PHOTO_PROFILE(usersData[uid].photoURL)}
  //         id={usersData[uid].uid}
  //       />,

  //       usersData[uid].firstName ? usersData[uid].firstName : '',
  //       usersData[uid].lastName ? usersData[uid].lastName : '',
  //       usersData[uid].nationality ? usersData[uid].nationality : '', // Country at position 3
  //       this.renderEmail(usersData[uid].email), // Email at position 4
  //       usersData[uid].userDescription, // User Type at position 5
  //       usersData[uid].points ? Math.round(Number(usersData[uid].points) / 10) / 10 : '', // numeric Lc at position 6 (1 decimal)
  //       usersData[uid].department ? usersData[uid].department : '', // Sector at position 7
  //       usersData[uid].position ? usersData[uid].position : '', // Position at position 8

  //       ddds ? ddds : '',
  //       usersData[uid].execmember ? 'Y' : 'N',
  //       usersData[uid].feedback ? usersData[uid].feedback : 'N',
  //       this.renderWallet(usersData[uid].wallet),
  //       this.formatPledgeValue(usersData[uid].lastPledgeDate, true),
  //       usersData[uid].mevInWallet !== undefined && usersData[uid].mevInWallet !== null && usersData[uid].mevInWallet !== ''
  //         ? Number(usersData[uid].mevInWallet).toFixed(2)
  //         : '',
  //       this.formatPledgeValue(usersData[uid].lastPledgeType, false),
  //       usersData[uid].uid ? usersData[uid].uid : '',
  //       usersData[uid].userID ? usersData[uid].userID : ''
  //     ]
  //   })

  //   return dataListClone
  // };

getTotalMevInWallet = async () => {
  try {
    const snapshot = await firebase.database.ref('user').once('value');
    const userdata = snapshot.val() || {};

    let totalMevInWallet = 0;

    Object.keys(userdata).forEach((uid) => {
      const user = userdata[uid];

      if (user && user.mevInWallet != null) {
        const mevAmount = Number(user.mevInWallet);

        if (Number.isFinite(mevAmount)) {
          totalMevInWallet += mevAmount;
        }
      }
    });
    console.log('totalMevInWallet: ', totalMevInWallet);
    return totalMevInWallet;

  } catch (error) {
    console.error('Error calculating total MEV in wallets:', error);
    return 0;
  }
};

  handleCloseGroupAdminDialog = () => {
    this.setState({ openGroupAdminDialog: false })
  }

  handleCloseGroupEditAdminDialog = () => {
    this.setState({ openGroupEditAdminDialog: false })
  }

  async handleDeleteUser() {
    const { deleteCompanyUser, showToast } = this.props

    let userProfile = window.su.data
    userProfile.uid = window.su.uid
    //get rid of duplicate account
    // console.log('handleDeleteUser uid: ', userProfile.uid);
    // console.log('handleDeleteUser profile: ', userProfile);

    // if (window.su.uid==='lJChGIcE45bJ3zcOJH770QG4YPv2') {
    //   await deleteCompanyUser({userProfile: userProfile});
    //    console.log('handleDeleteUser yes!!: ', window.su.uid);
    // }
    //  else { return }


    let currUserID = this.props.userdata.userID

    if (currUserID == userProfile.userID) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Cannot delete your own account!'
      })

      return
    }

    const answerEmail = prompt(
      `Are you sure you want to remove ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be deleted: Incorrect email address provided.'
      })

      return
    }
  ////////////////////////////////////////////////////////////////////////////////////////
  try {
    const result = await deleteCompanyUser({userProfile: userProfile}); // Execute Redux Thunk
    if (result) {

        showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'success',
          message: `Deleted ${userProfile.firstName} ${userProfile.lastName} successfully!`,
        })

    } else {
  
        showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: `Can't delete ${userProfile.firstName} ${userProfile.lastName} because their wallet still has either MEV or BNB in it`,
        })

    }
  } catch (error) {
    console.error('Error deleting user:', error);
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'An error occurred while attempting to delete the user',
      })
  }
//////////////////////////////////////////////////////////////////////////////////////////
    // deleteCompanyUser({
    //   userProfile: userProfile
    // })
    // showToast({
    //   type: 'SHOW_TOAST',
    //   open: true,
    //   variant: 'success',
    //   message: 'Deleted ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
    // })
  }
 ///////////////////////////////////////////////////////////////////////// 
  async ActivateUserLc() {
    const { showToast } = this.props
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;

    const answerEmail = prompt(
      `Are you sure you want to activate Lc for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be activated: Incorrect email address provided.'
      })

      return
    }
   //activate user Lc
   updates['/users/' + userID + '/userDescription'] = 'Public Contributor';
   updates['/users/' + userID + '/userType'] = 3;

   updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + '3';
   //updates['/users/' + userID + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
   updates['/users/' + userID + '/feedbackOn'] = true;
   updates['/users/' + userID + '/gfeedbackOn'] = true;
   
   updates['/users/' + userID + '/feedback'] = 1;
   updates['/users/' + userID + '/execmember'] = true;
   /////////////////////////////////////////////////////////////////////
   updates['/user/' + uid + '/userDescription'] = 'Public Contributor';
   updates['/user/' + uid + '/userType'] = 3;

   updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + '3';
  // updates['/user/' + uid + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
   updates['/user/' + uid + '/feedbackOn'] = true;
   updates['/user/' + uid + '/gfeedbackOn'] = true;

   updates['/user/' + uid + '/feedback'] = 1;
   updates['/user/' + uid + '/execmember'] = true;

            var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                     params: {
                         updates: updates, //user wallet address                       
                     }
               })
   
          if (res.data || res.data.success === true) {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'success',
               message: 'Activated Lc for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
             });
           }
           else {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'error',
               message: 'Failed to send activate Person',
             });
           }
   
  //  await database.ref().update(updates, function (error) {
  //   if (error) {
  //     showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'error',
  //       message: `${error}`      
  //     })
  //   } else {
  //     showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'success',
  //       message: 'Activated Lc for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
  //     })
  //   }
  // })
  }

  async DActivateUserLc() {
    const { showToast } = this.props
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;

    const answerEmail = prompt(
      `Are you sure you want to De-activate Lc for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be de-activated: Incorrect email address provided.'
      })

      return
    }
   //activate user Lc
   updates['/users/' + userID + '/userDescription'] = 'Public Contributor';
   updates['/users/' + userID + '/userType'] = 3;

   updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + '3';
   //updates['/users/' + userID + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
   updates['/users/' + userID + '/feedbackOn'] = true;
   updates['/users/' + userID + '/gfeedbackOn'] = true;
   
   updates['/users/' + userID + '/feedback'] = 1;
   updates['/users/' + userID + '/execmember'] = false;
   /////////////////////////////////////////////////////////////////////
   updates['/user/' + uid + '/userDescription'] = 'Public Contributor';
   updates['/user/' + uid + '/userType'] = 3;

   updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + '3';
  // updates['/user/' + uid + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
   updates['/user/' + uid + '/feedbackOn'] = true;
   updates['/user/' + uid + '/gfeedbackOn'] = true;

   updates['/user/' + uid + '/feedback'] = 1;
   updates['/user/' + uid + '/execmember'] = false;

            var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                     params: {
                         updates: updates, //user wallet address                       
                     }
               })
   
          if (res.data || res.data.success === true) {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'success',
               message: 'De-Activated Lc for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
             });
           }
           else {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'error',
               message: 'Failed to send de-activate Person',
             });
           }

  //  await database.ref().update(updates, function (error) {
  //   if (error) {
  //     showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'error',
  //       message: `${error}`      
  //     })
  //   } else {
  //     showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'success',
  //       message: 'De-Activated Lc for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
  //     })
  //   }
  // })
  }

  handleActivateLc() {
    const { showToast } = this.props

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID

    const answerEmail = prompt(
      `Are you sure you want to activate Lc for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be activated: Incorrect email address provided.'
      })

      return
    }

    ActivateUserLc({
      userProfile: userProfile
    })
    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'Activated ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
    })
  }
///////////////////////////////////////////////////////////////////////////
   async giveLcto() {
    const { showToast } = this.props
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;

    let whatItis;
    let pledgeInput;

    const answerEmail = prompt(
      `Are you sure you want to give Lc/Pledge to ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Lc cannot be given: Incorrect email address provided.'
      })

      return
    }

///////////////////////////////////////////////////////////////////////////////////////
  const message = `Please choose your option:\n\n` +
                  `1. Allocate Pledge & Lc\n` +
                  `2. Just Pledge\n\n` +
                  `3. Just Lc\n\n` +
                  `Please enter 1, 2 or 3:`;

  const chooseInput = prompt(message);

  if (chooseInput === null) {
    // User clicked Cancel
    return;
  }

  const num = Number(chooseInput?.trim());

  if (![1, 2, 3].includes(num)) {
    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'warning',
      message: 'Invalid input: Please enter just 1, 2 or 3.',
    });
    return;
  }

  // Valid choice
  if (num === 1) {
    console.log("User chose: Pledge & Lc");
    // Handle Allocate 1 logic
   // pledgeInput = 1;
    whatItis = 'Pledge & Lc';
  } 
  if (num === 2) {
    console.log("User chose: Just Pledge");
    // Handle Just Pledge logic
    //pledgeInput = 2;
    whatItis = 'Pledge';
  }
  if (num === 3) {
    console.log("User chose: Just Lc");
    // Handle Just Lc
    //pledgeInput = 3;
    whatItis = 'Lc';
  }
 
///////////////////////////////////////////////////////////////////////////////////////
    const numberInput = prompt(
      `Please enter the ${whatItis} amount for ${userProfile.firstName} ${userProfile.lastName}`
    );

    if (numberInput === '' || numberInput === null || isNaN(numberInput) || Number(numberInput) === 0) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: `Invalid input: Please enter a valid positive number for ${whatItis} amount.`
      });
      return; // Exit if invalid input
    }
    
    const lcAmount = numberInput;

    // Convert input to number and proceed
   // const pledgeYes = Number(pledge);

     const patronemail = userProfile.email;
     console.log('xpledgeStart patronEmail 1: ', patronemail);
     console.log('xpledgeStart patronEmail 2: ', lcAmount);
     
   try {
     this.handleLcLog(lcAmount, userProfile.uid, userProfile.userID, userProfile.email, userProfile.points, num);
      // showToast({
      //   type: 'SHOW_TOAST',
      //   open: true,
      //   variant: 'success',
      //   message: 'Lc given to ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
      // })
    
   } catch (err) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: `${err}`      
      })
   }
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

 handleLcLog = async (numberInput, uid, userID, pname, points, pledge) => {
     // const { RequestUid, RequestPerson } = this.state;
     //this.handleLcLog(lcAmount, userProfile.uid, userProfile.firstName);
     // const COSIGNA = process.env.REACT_APP_COSIGNA;
     // const COSIGNC = process.env.REACT_APP_COSIGNC;

   console.log('handleLcLog : numberInput: ', numberInput + ' uid:' + uid + ' userID:' + userID + ' points:' + points + ' pledge:' + pledge);

      var updates = {};
      let returnMsg;

      console.log('inside handleLcLog 1: ', numberInput);

      const mid = this.makeid(10);
      console.log('inside handleLcLog 2: ', mid);

 let pledgeString;

  switch (pledge) {
    case 1:
      pledgeString = 'Pledge and Lc';
      break;

    case 2:
      pledgeString = 'Pledge';
      break;

    case 3:
      pledgeString = 'Lc';
      break;

    default:
      pledgeString = 'Pledge'; // fallback
      console.warn(`Unexpected pledge value: ${pledge}. Defaulting to 'Pledge'`);
      break;
  }

      if (numberInput !== '') {
        console.log('inside handleLcLog 3: ', this.props.userdata);
        updates['/CoSign/' + mid] = {
            id: mid,
            LcGiven: Number(numberInput),
            currpoints: points,
            type: pledgeString,
            RequestUid: this.props.userdata.uid,
            RequestPerson: this.props.userdata.firstName,
            targetuid: uid,
            targetuserID: userID,
            targetname: pname,
            active: true,
            pledge: pledge,
        }
       console.log('inside handleLcLog 4: ', updates);

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

          if (res.data || res.data.success === true) {
            console.log('Successfully updated Lc given:', numberInput);

            returnMsg = `The ${pledgeString} will be allocated when approved by co-signing`;

            this.props.showToast({
              type: SHOW_TOAST,
              open: true,
              variant: 'success',
              message: returnMsg,
            });
          }
          else {
            console.error('Error updating AllowToSell:');
            this.props.showToast({
              type: SHOW_TOAST,
              open: true,
              variant: 'error',
              message: `Failed to allocate your ${pledgeString}` ,
            })
          }
      } else {
        console.log('Please enter a valid number');
        this.props.showToast({
          type: SHOW_TOAST,
          open: true,
          variant: 'error',
          message: 'Please enter a valid number',
        });
      }
    };

    GroupPledge = async (numberInput, uid, userID, pname, points, pledge, chooseInput) => {
      var updates = {};
      console.log('inside handleLcLog 1: ', numberInput);

      const mid = this.makeid(10);
      console.log('inside handleLcLog 2: ', mid);

      if (numberInput !== '') {
        console.log('inside handleLcLog 3: ', this.props.userdata);
        updates['/CoSign/' + mid] = {
            id: mid,
            LcGiven: Number(numberInput),
            currpoints: points,
            type: 'Group proxy Pledge',
            RequestUid: this.props.userdata.uid,
            RequestPerson: this.props.userdata.firstName,
            targetuid: uid,
            targetuserID: userID,
            targetname: pname,
            active: true,
            pledge: pledge,
            chooseInput: chooseInput,
        }

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

          if (res.data || res.data.success === true) {
            console.log('Successfully allocated Group Pledge:', numberInput);
            this.props.showToast({
              type: SHOW_TOAST,
              open: true,
              variant: 'success',
              message: `Group pledge of ${Number(numberInput)} will be activated when approved by co-signing`,
            });
          }
          else {
            console.error('Error updating AllowToSell:');
            this.props.showToast({
              type: SHOW_TOAST,
              open: true,
              variant: 'error',
              message: 'Failed to allocate Lc',
            })
          }
      } else {
        console.log('Please enter a valid number');
        this.props.showToast({
          type: SHOW_TOAST,
          open: true,
          variant: 'error',
          message: 'Please enter a valid number',
        });
      }
    };
  
async confirmFlexPledge() {
    const { showToast } = this.props
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;
   try {
    const answerEmail = prompt(
      `Are you sure you want to Confirm Pledge for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be confirmed: Incorrect email address provided.'
      })

      return
    }

    const numberInput = prompt(
      `Please enter the Pledge amount for ${userProfile.firstName} ${userProfile.lastName} Pledge`
    );

    if (numberInput === '' || numberInput === null || isNaN(numberInput) || Number(numberInput) === 0) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Invalid input: Please enter a valid positive number for Lc amount.'
      });
      return; // Exit if invalid input
    }

    const pledgepers = prompt(
      `Please select the Pledge Percentage for ${userProfile.firstName} ${userProfile.lastName} Pledge.
      Enter 1 to select 0%, Enter 2 to select 25%, Enter 3 to select 50%`
    );

    if (pledgepers === '' || pledgepers === null || isNaN(pledgepers) || Number(pledgepers) === 0) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Invalid input: Please enter a valid positive number for Lc amount.'
      });
      return; // Exit if invalid input
    }

    // Convert input to number and proceed
    const lcAmount = Number(numberInput);
    const flcAmount = lcAmount * 100;
    const patronemail = userProfile.email;

    localStorage.setItem('lcAmount', flcAmount);
    localStorage.setItem('targetEmail', patronemail);

    if (pledgepers==='1') {
      localStorage.setItem('pledgepers', 0);
    }
    if (pledgepers==='2') {
      localStorage.setItem('pledgepers', 0.25);
    }
    if (pledgepers==='3') {
      localStorage.setItem('pledgepers', 0.50);
    }

    //const url = `http://thinklead.app/gotopersonpledge?patronemail=${encodeURIComponent(patronemail)}`; 
    //const url = `http://localhost:3000/gotoflexpledge?patronemail=${encodeURIComponent(patronemail)}`;
    const url = `http://localhost:3000/gotoflexpledge`;

    console.log('xpledgeStart Redirecting to:', url); // Debug: Log the full URL
    window.location.href = url;

      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: 'Pledge Confirmed for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
      })
    }
   catch (error) {
          showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: `${error}`      
      })
   }
  }   

async confirmGIFPledge() {
    const { showToast } = this.props
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;
   try {
    const answerEmail = prompt(
      `Are you sure you want to Confirm Pledge for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be confirmed: Incorrect email address provided.'
      })

      return
    }

    const numberInput = prompt(
      `Please enter the amount in Lc`
    );

    if (numberInput === '' || numberInput === null || isNaN(numberInput) || Number(numberInput) === 0) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Invalid input: Please enter a valid positive number for Lc amount.'
      });
      return; // Exit if invalid input
    }

    // const pledgepers = prompt(
    //   `Please select the Pledge allocation.
    //   Enter 1 to select 0%, Enter 2 to select 25%, Enter 3 to select 50%`
    // );

    // if (pledgepers === '' || pledgepers === null || isNaN(pledgepers) || Number(pledgepers) === 0) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: 'Invalid input: Please enter a valid positive number for Lc amount.'
    //   });
    //   return; // Exit if invalid input
    // }

    // Convert input to number and proceed
    const lcAmount = Number(numberInput);
    const flcAmount = lcAmount * 100;
    const patronemail = userProfile.email;

    localStorage.setItem('lcAmount', flcAmount);
    localStorage.setItem('targetEmail', patronemail);

    //if (pledgepers==='1') {
    pledgepers = '1'
    localStorage.setItem('pledgepers', 0);
    // }
    // if (pledgepers==='2') {
    //   localStorage.setItem('pledgepers', 0.25);
    // }
    // if (pledgepers==='3') {
    //   localStorage.setItem('pledgepers', 0.50);
    // }

    //const url = `http://thinklead.app/gotopersonpledge?patronemail=${encodeURIComponent(patronemail)}`; 
    //const url = `http://localhost:3000/gotoflexpledge?patronemail=${encodeURIComponent(patronemail)}`;
    const url = `http://localhost:3000/gotoGIFpledge`;

    console.log('xpledgeStart Redirecting to:', url); // Debug: Log the full URL
    window.location.href = url;

      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: 'Pledge Confirmed for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
      })
    }
   catch (error) {
          showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: `${error}`      
      })
   }
  }   
///////////////////////////////////////////////////////////////////////////
  async confirmUserPledge() {
    const { showToast } = this.props
    try {
    let updates = {}
    let database = firebase.database;

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID
    let userID = currUserID;
    let uid = userProfile.uid;
    let companyID = this.props.userdata.companyID;

    const answerEmail = prompt(
      `Are you sure you want to Confirm Pledge for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be confirmed: Incorrect email address provided.'
      })

      return
    }
   //confirm pledge
  //userProfile.email
  //  await GotoPersonPledge ({
  //    patronemail: userProfile.email
  //  })
     const patronemail = userProfile.email;
     console.log('xpledgeStart patronEmail 1: ', patronemail);

    //const url = `http://thinklead.app/gotopersonpledge?patronemail=${encodeURIComponent(patronemail)}`; 
    const url = `http://localhost:3000/gotopersonpledge?patronemail=${encodeURIComponent(patronemail)}`;
    console.log('xpledgeStart Redirecting to:', url); // Debug: Log the full URL
    window.location.href = url;

      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: 'Pledge Confirmed for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
      })
   } catch (error) {
       onsole.error("Error updating LCPOOL:", error.message);
        showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: `${error}`      
      })
   }
  }

  async PledgeByProxy(numSelected) { //activate/pledge/ user group
    let { classes, userdata, users, showToast } = this.props
    let database = firebase.database
    let updates = {}
    let userProfile = window.su
    let uid;
    let userID;
    let currUserID = this.props.userdata.userID
    let companyID;

    let allActivatedUsers = ''
    let suicide = false

    const answerYes = prompt(
      `Are you sure you want to Confirm Proxy Pledge ${allActivatedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )

    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Pledge cancelled.'
      })

      return
    }

///////////////////////////////////////////////////////////////////////////////////////

  const message = `Please choose your option:\n\n` +
                  `1. Allocate Pledge & Lc\n` +
                  `2. Just Pledge\n\n` +
                  `Please enter 1 or 2:`;

  const chooseInput = prompt(message);

  if (chooseInput === null) {
    // User clicked Cancel
    return;
  }

  const num = Number(chooseInput?.trim());

  if (![1, 2].includes(num)) {
    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'warning',
      message: 'Invalid input: Please enter just 1 or 2.',
    });
    return;
  }

  // Valid choice
  if (num === 1) {
    console.log("User chose: Pledge & Lc");
    // Handle Allocate 1 logic
    //chooseInput = 1;
  } else {
    console.log("User chose: Just Pledge");
    // Handle Just Pledge logic
    //chooseInput = 2;
  }

///////////////////////////////////////////////////////////////////////////////////////
    const numberInput = prompt(
      `Please enter the Lc amount for group pledge`
    );

    if (numberInput === '' || numberInput === null || isNaN(numberInput) || Number(numberInput) === 0) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Invalid input: Please enter a valid positive number for Lc amount.'
      });
      return; // Exit if invalid input
    }

    // Build the email array
      // let emailArray = [];
      // if (userProfile && Object.keys(userProfile).length > 0) {
      //   emailArray = Object.keys(userProfile)
      //     .map((v) => {
      //       const email = userProfile[v]?.data?.email; // Safe access with optional chaining
      //       return email ? String(email).trim().toLowerCase() : null; // Normalize and lowercase
      //     })
      //     .filter(email => email !== null && email !== ''); // Remove nulls/empties
      // }
    let lcAmount = numberInput;
    let pledge = lcAmount * 100;
    let data = userProfile &&
      Object.keys(userProfile).map((v, i) => {
        // resetYCompanyUser({
        //   userProfile: userProfile[v].data
        // })

        console.log('pledgebyproxy pledge: ', pledge);

         console.log('pledgebyproxy userProfile[i].data: ', userProfile[i].data.email);
        this.GroupPledge(lcAmount, userProfile[i].data.uid, userProfile[i].data.userID, userProfile[i].data.email, userProfile[i].data.points, pledge, num);

      })

    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'Group Pledge went through and will be confirmed after Co-sign is done.'
    })
  }

  async handleBulkPledge(numSelected) { //activate Lc for more than 1
    let { classes, userdata, users, showToast } = this.props
    let database = firebase.database
    let updates = {}
    let userProfile = window.su
    let uid;
    let userID;
    let currUserID = this.props.userdata.userID
    let companyID;

    let allActivatedUsers = ''
    let suicide = false

    const answerYes = prompt(
      `Are you sure you want to Confirm Patreon Pledge for ${allActivatedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )

    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Activation process cancelled.'
      })

      return
    }

    // Build the email array
      let emailArray = [];
      if (userProfile && Object.keys(userProfile).length > 0) {
        emailArray = Object.keys(userProfile)
          .map((v) => {
            const email = userProfile[v]?.data?.email; // Safe access with optional chaining
            return email ? String(email).trim().toLowerCase() : null; // Normalize and lowercase
          })
          .filter(email => email !== null && email !== ''); // Remove nulls/empties
      }

      // Store the array in localStorage (to pass it without URL params)
      localStorage.setItem('patronEmails', JSON.stringify(emailArray));

      // Redirect to the other page
      const url = `http://localhost:3000/gotobulkpledge`;
      window.location.href = url;
    ////////////////////////////////////////////////////////////////////////
    // let emailArray = userProfile
    //   ? Object.keys(userProfile).map((key) => userProfile[key].data.email)
    //   : [];

    // // Store the array in sessionStorage to pass it to GotoBulkPledge.js
    // sessionStorage.setItem('emailArray', JSON.stringify(emailArray));

    // // Redirect to GotoBulkPledge.js
    // const url = `http://localhost:3000/gotobulkpledge`;
    // window.location.href = url;
    ////////////////////////////////////////////////////////////
    // let sdata = userProfile &&
    //   Object.keys(userProfile).map((v, i) => {
    //     // let uid = userProfile[v].data.uid;
    //     // let userID = userProfile[v].data.userID;
    //     let patronemail = userProfile[v].data.email;

    //     console.log('handleBulkPledge email: ', patronemail);

    //   })

    // const url = `http://localhost:3000/gotobulkpledge`;
    // console.log('xpledgeStart Redirecting to:', url); // Debug: Log the full URL
    // window.location.href = url;
      
  }

handleResetYUser() {
    const { resetYCompanyUser, showToast } = this.props

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID

    // if (currUserID == userProfile.userID) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: 'Cannot delete your own account!'
    //   })

    //   return
    // }

    const answerEmail = prompt(
      `Are you sure you want to Reset Annual LC for ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )

    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User annual points cannot be reset: Incorrect email address provided.'
      })

      return
    }

    resetYCompanyUser({
      userProfile: userProfile
    })

    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'Reset Annual LC for ' + userProfile.firstName + ' ' + userProfile.lastName + ' successfully!'
    })
  }

  handleBulkDeleteUser(deleteCompanyUser, numSelected) {
    let { classes, userdata, users, showToast } = this.props

    let userProfile = window.su

    let currUserID = this.props.userdata.userID
    let allDeletedUsers = ''
    let suicide = false

    let sdata =
      userProfile &&
      Object.keys(userProfile).map((v, i) => {
        allDeletedUsers = allDeletedUsers + '\n' + userProfile[v].data.firstName + ' ' + userProfile[v].data.lastName + '\n'
        if (currUserID == userProfile[v].data.userID) {
          suicide = true
        }
      })
    

    if (suicide == true) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Cannot delete your own account!'
      })

      return
    }

    const answerYes = prompt(
      `Are you sure you want to remove ${allDeletedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )


    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Delete process cancelled.'
      })

      return
    }

    let data = userProfile &&
      Object.keys(userProfile).map((v, i) => {
        deleteCompanyUser({
          userProfile: userProfile[v].data
        })
      })

    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'Deleted ' + '\n' + allDeletedUsers + ' successfully!'
    })
  }


  async handleBulkLc(numSelected) { //activate Lc for more than 1
    let { classes, userdata, users, showToast } = this.props
      let database = firebase.database
    let updates = {}
    let userProfile = window.su
    let uid;
    let userID;
    let currUserID = this.props.userdata.userID
    let companyID;

    let allActivatedUsers = ''
    let suicide = false

    let sdata =
    userProfile &&
    Object.keys(userProfile).map((v, i) => {
      allActivatedUsers = allActivatedUsers + '\n' + userProfile[v].data.firstName + ' ' + userProfile[v].data.lastName + '\n'
      if (currUserID == userProfile[v].data.userID) {
        suicide = true
      }
    })
    

    // if (suicide == true) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: 'Cannot delete your own account!'
    //   })

    //   return
    // }

    const answerYes = prompt(
      `Are you sure you want to activate Lc for ${allActivatedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )


    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Activation process cancelled.'
      })

      return
    }

    sdata = userProfile &&
      Object.keys(userProfile).map((v, i) => {
        let uid = userProfile[v].data.uid;
        let userID = userProfile[v].data.userID;
        let companyID = userProfile[v].data.companyID;

        console.log('handleBulkLc userID: ', userID);

      if (uid!==undefined) {
      //////////////////////////////////////////////////////////////////////////////
      //activate user Lc
      updates['/users/' + userID + '/userDescription'] = 'Public Contributor';
      updates['/users/' + userID + '/userType'] = 3;

      updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + '3';
      //updates['/users/' + userID + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
      updates['/users/' + userID + '/feedbackOn'] = true;
      updates['/users/' + userID + '/gfeedbackOn'] = true;
      
      updates['/users/' + userID + '/feedback'] = 1;
      updates['/users/' + userID + '/execmember'] = true;
      /////////////////////////////////////////////////////////////////////
      updates['/user/' + uid + '/userDescription'] = 'Public Contributor';
      updates['/user/' + uid + '/userType'] = 3;

       updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + '3';
      // updates['/user/' + uid + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
      updates['/user/' + uid + '/feedbackOn'] = true;
      updates['/user/' + uid + '/gfeedbackOn'] = true;

      updates['/user/' + uid + '/feedback'] = 1;
      updates['/user/' + uid + '/execmember'] = true;

      }
      })
      
          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })
   
          if (res.data || res.data.success === true) {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'success',
               message: 'Activated Lc for People successfully!'
             });
           }
           else {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'error',
               message: 'Failed to send activate Lc',
             });
           }    
      // await database.ref().update(updates, function (error) {
      //   if (error) {
      //     showToast({
      //       type: 'SHOW_TOAST',
      //       open: true,
      //       variant: 'error',
      //       message: `${error}`      
      //     })
      //   } else {
      //     showToast({
      //       type: 'SHOW_TOAST',
      //       open: true,
      //       variant: 'success',
      //       message: 'Activated Lc successfully for Patrons.'
      //     })
      //   }
      // })
  }

  async DhandleBulkLc(numSelected) { //activate Lc for more than 1
    let { classes, userdata, users, showToast } = this.props
      let database = firebase.database
    let updates = {}
    let userProfile = window.su
    let uid;
    let userID;
    let currUserID = this.props.userdata.userID
    let companyID;

    let allActivatedUsers = ''
    let suicide = false

    let sdata =
    userProfile &&
    Object.keys(userProfile).map((v, i) => {
      allActivatedUsers = allActivatedUsers + '\n' + userProfile[v].data.firstName + ' ' + userProfile[v].data.lastName + '\n'
      if (currUserID == userProfile[v].data.userID) {
        suicide = true
      }
    })
    

    // if (suicide == true) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: 'Cannot delete your own account!'
    //   })

    //   return
    // }

    const answerYes = prompt(
      `Are you sure you want to De-activate Lc for ${allActivatedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )


    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'De-Activation process cancelled.'
      })

      return
    }

    sdata = userProfile &&
      Object.keys(userProfile).map((v, i) => {
        let uid = userProfile[v].data.uid;
        let userID = userProfile[v].data.userID;
        let companyID = userProfile[v].data.companyID;

        console.log('handleBulkLc userID: ', userID);

      if (uid!==undefined) {
      //////////////////////////////////////////////////////////////////////////////
      //activate user Lc
      updates['/users/' + userID + '/userDescription'] = 'Public Contributor';
      updates['/users/' + userID + '/userType'] = 3;

      updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + '3';
      //updates['/users/' + userID + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
      updates['/users/' + userID + '/feedbackOn'] = true;
      updates['/users/' + userID + '/gfeedbackOn'] = true;
      
      updates['/users/' + userID + '/feedback'] = 1;
      updates['/users/' + userID + '/execmember'] = false;
      /////////////////////////////////////////////////////////////////////
      updates['/user/' + uid + '/userDescription'] = 'Public Contributor';
      updates['/user/' + uid + '/userType'] = 3;

       updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + '3';
      // updates['/user/' + uid + '/LeaderboardKey'] = params.companyID + '_' + nationality + '_' + position + '_' + department
      updates['/user/' + uid + '/feedbackOn'] = true;
      updates['/user/' + uid + '/gfeedbackOn'] = true;

      updates['/user/' + uid + '/feedback'] = 1;
      updates['/user/' + uid + '/execmember'] = false;

      }
    })
     
            var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })
   
          if (res.data || res.data.success === true) {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'success',
               message: 'De-Activated Lc for people successfully!'
             });
           }
           else {
             showToast({
               type: SHOW_TOAST,
               open: true,
               variant: 'error',
               message: 'Failed to send de-activate people',
             });
           }

      // await database.ref().update(updates, function (error) {
      //   if (error) {
      //     showToast({
      //       type: 'SHOW_TOAST',
      //       open: true,
      //       variant: 'error',
      //       message: `${error}`      
      //     })
      //   } else {
      //     showToast({
      //       type: 'SHOW_TOAST',
      //       open: true,
      //       variant: 'success',
      //       message: 'De-Activated Lc successfully for Patrons.'
      //     })
      //   }
      // })
  }
  
  handleResetBulkUsers(resetYCompanyUser, numSelected) {
    let { classes, userdata, users, showToast } = this.props

    let userProfile = window.su

    let currUserID = this.props.userdata.userID
    let allDeletedUsers = ''

    // let sdata =
    // userProfile &&
    // Object.keys(userProfile).map((v, i) => {
    //   allDeletedUsers = allDeletedUsers + '\n' + userProfile[v].data.firstName + ' ' + userProfile[v].data.lastName + '\n'
    //   if (currUserID == userProfile[v].data.userID) {
    //     suicide = true
    //   }
    // })

    // if (suicide == true) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: 'Cannot delete your own account!'
    //   })

    //   return
    // }

    const answerYes = prompt(
      `Are you sure you want to Reset Annual LC for ${allDeletedUsers} \n ( Please type 'yes' if you want to proceed !) `
    )

    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
    if (answerYes === '' || answerYes === null) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Reset of Annual LC cancelled.'
      })

      return
    }

    let data = userProfile &&
      Object.keys(userProfile).map((v, i) => {
        resetYCompanyUser({
          userProfile: userProfile[v].data
        })
      })

    showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'Annual LC Reset ' + '\n' + allDeletedUsers + ' successfully!'
    })
  }

  yyhandleDeleteUser(deleteCompanyUser, numSelected) {
    const { showToast } = this.props

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID

    if (currUserID == userProfile.userID) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Cannot delete your own account!'
      })

      return
    }

    // const answerEmail = prompt(
    //   `Are your sure you want to remove ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    // );


    // if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
    //   showToast({
    //     type: 'SHOW_TOAST',
    //     open: true,
    //     variant: 'warning',
    //     message: "User cannot be deleted: Incorrect email address provided."
    //   });

    //   return;
    // }

    // showToast({
    //   type: 'SHOW_TOAST',
    //   open: true,
    //   variant: 'error',
    //   message: "User deleted."
    // });

    // return;
    // deleteCompanyUser({
    //   userProfile: userProfile
    // })
  }

  xxhandleDeleteUser() {
    const { deleteCompanyUser, showToast } = this.props

    let userProfile = window.su.data
    userProfile.uid = window.su.uid

    let currUserID = this.props.userdata.userID

    if (currUserID == userProfile.userID) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Cannot delete your own account!'
      })

      return
    }

    const answerEmail = prompt(
      `Are you sure you want to remove ${userProfile.firstName} ${userProfile.lastName} \n ( Please type in the email of the User !) `
    )


    if (answerEmail === '' || answerEmail === null || answerEmail !== userProfile.email) {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'User cannot be deleted: Incorrect email address provided.'
      })

      return
    }

    // showToast({
    //   type: 'SHOW_TOAST',
    //   open: true,
    //   variant: 'error',
    //   message: "User deleted."
    // });

    // return;
    deleteCompanyUser({
      userProfile: userProfile
    })
  }

  handleOpenDialog = () => {
    this.setState({ openDialog: true, edit: false, editedUser: {} })
    this.handleClose()
  };

  handleEditUserDialog = () => {
    this.setState({ openDialog: true, edit: true, editedUser: window.su.data })
  };

  formatDate(date) {
    let d = new Date(date)


    let month = '' + (d.getMonth() + 1)


    let day = '' + d.getDate()


    let year = d.getFullYear()


    let hours = '' + d.getHours()


    let minutes = '' + d.getMinutes()


    let seconds = '' + d.getSeconds()


    let milliseconds = '' + d.getMilliseconds()

    let today = new Date()


    let thisYear = today.getFullYear()

    // get week day name Sunday - Saturday
    let dayName = this.getDayMonthStr(d.getDay(), 'day', true)

    // get month name
    let monthName = this.getDayMonthStr(d.getMonth(), 'month', true)

    // add preceding zeros where needed
    if (month.length < 2) {
      month = '0' + month
    }
    if (day.length < 2) {
      day = '0' + day
    }
    if (hours.length < 2) {
      hours = '0' + hours
    }
    if (minutes.length < 2) {
      minutes = '0' + minutes
    }
    if (seconds.length < 2) {
      seconds = '0' + seconds
    }
    if (milliseconds.length < 2) {
      milliseconds = '0' + milliseconds
    }

    // format thoughts date
    // Monday, 04 December 2017 14:21:56
    let thoughtDate =
      dayName +
      ', ' +
      day +
      ' ' +
      monthName +
      ' ' +
      year +
      ' ' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds

    return thoughtDate
    // return [year, month, day].join('-');
  }

  getDayMonthStr(val, dateParam, long) {
    // days
    let days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]
    let daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat']

    // Months
    let monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    let monthNamesShort = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]

    if (dateParam === 'day' && long === true) {
      // return day in long format
      return days[val]
    } else if (dateParam === 'day' && long === false) {
      // return days in short
      return daysShort[val]
    }
    if (dateParam === 'month' && long === true) {
      // return month in long format
      return monthNames[val]
    } else if (dateParam === 'month' && long === false) {
      // return month in short
      return monthNamesShort[val]
    }
  }

  openGroupAdmin = event => {
    this.setState({ openGroupAdminDialog: true })
  }

  openGroupEditAdmin = event => {
    this.setState({ openGroupEditAdminDialog: true })
  }

  openEditGroupAdmin = event => {
    this.setState({ openEditGroupAdminDialog: true })
  }

  onChangeHandler = (event) => {
    

    if (!event.target.files || !event.target.files[0]) {
      
      return;
    }
    const file = event.target.files[0];
    

    const { simpleAction } = this.props;
    

    let companyID = this.props.userdata.companyID;
    let companyName = this.props.userdata.companyName;
    

    let reader = new FileReader();
    let timeInMs = Date.now();
    let datetime = new Date(timeInMs);
    

    datetime = this.formatDate(datetime);
    

   reader.onload = function (e) {
      
      let data = e.target.result;
      

      let body = {
        type: SIMPLE_VALUES,
        surveyid: true
      };
      simpleAction(body);
      

      try {
        
        let workbook = XLSX.read(data, { type: 'binary' });
        

        function to_json(workbook) {
          let result = {};
          
          workbook.SheetNames.forEach(function (sheetName) {
            
            const sheet = workbook.Sheets[sheetName];
            

            if (!sheet || !sheet['!ref']) {
              
              result[sheetName] = [];
              return;
            }

            try {
              
              let roa = XLSX.utils.sheet_to_row_object_array(sheet);
              
              if (roa.length > 0) {
                result[sheetName] = roa;
              } else {
                
                result[sheetName] = [];
              }
            } catch (error) {
              
              result[sheetName] = [];
            }
          });
          
          return result;
        }

        let xls_json = to_json(workbook);
        

        // Process users and upload to Firebase
        let users;
        Object.keys(xls_json).forEach(key => {
          users = xls_json[key];
          
          users.forEach((userobj, index) => {
            let email = userobj.Email;
            if (email && email.length > 5) {
              
              let userID = firebase.database.ref().child('newUploadUsers').push().key;
              let defPassword = Math.random().toString(36).substring(2, 17).toUpperCase();

              let data = {
                companyID: companyID,
                companyName: companyName,
                dateRegistered: timeInMs,
                email: userobj.Email,
                firstName: userobj.Firstname,
                lastName: userobj.Lastname,
                surName: userobj.Surname || '',
                points: userobj.points || '',
                position: userobj.position || '',
                nationality: userobj.nationality || '',
                idNumber: userobj.idNumber || '',
                department: userobj.department || '',
                password: defPassword,
                stringDateRegistered: datetime,
                userDescription: userobj['User Type'] || 'Standard User',
                newUploadUserID: userID,
                userType: 8,
                companyID_userType: companyID + '_' + (userobj['User Type'] || 'Standard User')
              };

              let updates = {};
              updates['/newUploadUsers/' + userID] = data;

        //  var res = axios.post(`${FB_URL}/m115-freshcard`, {
        //       params: {
        //             updates: updates,                       
        //         }
        //       })

        //   if (res.data || res.data.success === true) {
        //       console.log('success! onChangeHangler CompanyAdmin.js');      
        //    }
        //   else {
        //       console.log('Error onChangeHangler CompanyAdmin.js');
        //   }; 

              firebase.database.ref().update(updates, error => {
                if (error) {
                  
                } else {
                  
                }
              });
            } else {
              
            }
          });
        });

        // Finalize upload
        let body = {
          type: SIMPLE_VALUES,
          surveyid: false
        };
        simpleAction(body);
        
      } catch (error) {
        
      }
    };

    reader.onerror = function (e) {
      
    };

    
    reader.readAsBinaryString(file);
    

    this.handleClose();
    

    event.target.value = '';
    
  };


  handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget })
  }
  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  //////GET LCPOOL////////////////////////////////////////////////////
  getLCPOOLValue = async () => {
    
    try {
      const snapshot = await firebase.database
        .ref('patreon/LCPOOL').once('value');
      const LCPOOLValue = snapshot.val();
      
      // return LCPOOLValue;
      this.setState({ LCPOOLValue: LCPOOLValue })
    } catch (error) {
      
      return null;
    }
  };
  //////////////////////////////////////////////////////////////////////////

  render() {
    const { classes, match, location, users, showToast, userdata } = this.props
    const COSIGNA = this.decryptUID(process.env.REACT_APP_COSIGNA);
    const COSIGNC = this.decryptUID(process.env.REACT_APP_COSIGNC);
    
    const allowedUids = [
      COSIGNC, // Christo
      COSIGNA, // Adriaan
    ];

    // Build columns with persisted visibility
const getColumnsWithVisibility = () => this.columns.map(col => {
  const isMobileView = this.isMobile()
  const initialDisplay = isMobileView
    ? MOBILE_DEFAULT_COLUMNS.has(col.name)
    : (col.options && typeof col.options.display !== 'undefined' ? col.options.display : true)
  const persisted = Object.prototype.hasOwnProperty.call(this.state.visibleColumns, col.name)
    ? this.state.visibleColumns[col.name]
    : initialDisplay

  const px = isMobileView ? MOBILE_COL_PX[col.name] : undefined
  const existingBodyRender = col.options && col.options.customBodyRender
  const isFirstVisibleCol = col.name === 'Firstname'
  const MOBILE_GAP_PX = 5

  const cellWidthStyle = px
    ? {
        width: `${px}px`,
        maxWidth: `${px}px`,
        minWidth: `${px}px`,
        boxSizing: 'border-box',
        paddingRight: isMobileView ? `${MOBILE_GAP_PX}px` : undefined
      }
    : {}
  const leftGapStyle = isMobileView && isFirstVisibleCol ? { paddingLeft: '14px' } : {}

  return {
    ...col,
    options: {
      ...(col.options || {}),
      display: persisted,
      setCellProps: () => ({ style: { ...cellWidthStyle, ...leftGapStyle } }),
      setCellHeaderProps: () => ({ style: { ...cellWidthStyle, ...leftGapStyle } }),
      customHeadLabelRender: () => (
        <div style={isMobileView ? truncatedCellStyle(isFirstVisibleCol ? px - 14 - MOBILE_GAP_PX : px - MOBILE_GAP_PX, true) : undefined}>
          {col.name}
        </div>
      ),
      customBodyRender: (value, tableMeta, updateValue) => {
        const rendered = existingBodyRender
          ? existingBodyRender(value, tableMeta, updateValue)
          : value
        return isMobileView
          ? <div style={truncatedCellStyle(isFirstVisibleCol ? px - 14 : px - MOBILE_GAP_PX, false)}>{rendered}</div>
          : rendered
      },
          }
        }
      })
    const handleColumnViewChange = (changedColumn, action) => {
      // action: 'add' (show) or 'remove' (hide)
      this.setState(prev => ({
        visibleColumns: { ...prev.visibleColumns, [changedColumn]: action === 'add' }
      }))
    }

    // Build options with current mobile sort and visibility handler without mutating base options
const mergedOptions = {
  ...this.options,
  sortOrder: this.state.mobileSort ? { name: this.state.mobileSort.colName, direction: this.state.mobileSort.order } : this.options.sortOrder,
  onColumnViewChange: handleColumnViewChange
}

    // Compute table data once; uses cached users if Redux store is empty
  //const tableData = this.transformTableData()
  const tableData = this.state.tableData;

    let StyledMenu = withStyles({
      paper: {
        border: '1px solid #d3d4d5',
        backgroundColor: LIGHTGREY
      }
    })((props) => (
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        {...props}
      />
    ))

    let StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          'backgroundColor': theme.palette.primary.main,
          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
            color: theme.palette.common.white
          }
        }
      }
    }))(MenuItem)

    console.log('companyAdminTest 1')
    return (

      <Paper style={{ maxWidth: '120vw' }} className={classes.pageHeader}>
        <div>
          {this.props.simplething === true ?
            <div style={{
              width: '100%',
              height: '20px'
            }}><LeaderLoader /></div>
            : null}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button
            className={classes.btn}
            aria-controls='customized-menu'
            aria-haspopup='true'
            variant='outlined'
            color='primary'
            size='small'
            onClick={this.handleClick}
          >
            ACTIONS
            <ArrowDropDownIcon />
          </Button>
          {/* AI Filter toggle for leads - company level */}
          <AILeadFilterToggle userdata={this.props.userdata} />
          <StyledMenu
            id='customized-menu'
            anchorEl={this.state.anchorEl}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
            {/* {this.props.userdata.userType === 14 || 21 ? null : */}
            {[14, 21].includes(this.props.userdata.userType) ? null : (
              <StyledMenuItem
                onClick={this.handleOpenDialog}
              >
                <ListItemIcon>
                  <PersonAddIcon fontSize='medium' />
                </ListItemIcon>
                <ListItemText primary='Add User' />

              </StyledMenuItem>
            )}

            {/* {this.props.userdata.userType === 14 || 21  ? null : */}
             {[14, 21].includes(this.props.userdata.userType) ? null : (
              <input
                className={classes.input}
                style={{ display: 'none' }}
                id='raised-button-file'
                type='file'
                onChange={this.onChangeHandler}
              />
           )}

            {/* {this.props.userdata.userType === 14 || 21  ? null : */}
              {[14, 21].includes(this.props.userdata.userType) ? null : (
              <label htmlFor='raised-button-file'>
                <StyledMenuItem
                  // variant='raised'
                  component='span'
                  variant='contained'
                  color='primary'
                >
                  <ListItemIcon>
                    <GroupAddIcon fontSize='medium' />
                  </ListItemIcon>
                  <ListItemText primary='Upload Users (XLS)' />
                </StyledMenuItem>
              </label>
           )}

            {/* <StyledMenuItem
              onClick={this.openGroupAdmin}
            >
              <ListItemIcon>
                <GroupAddIcon fontSize='small' />
              </ListItemIcon>
              <ListItemText primary='Add Group' />
            </StyledMenuItem>

            <StyledMenuItem
              onClick={this.openGroupEditAdmin}
            >
              <ListItemIcon>
                <EditIcon fontSize='small' />
              </ListItemIcon>
              <ListItemText primary='Edit Group' fontSize='small' />
            </StyledMenuItem> */}

            <StyledMenuItem
              component={Link}
              to={`/groups`}
              variant='contained'
            >

              <ListItemIcon>
                <GroupWorkIcon fontSize='small' />
              </ListItemIcon>
              <ListItemText primary='Manage Groups' />
            </StyledMenuItem> 

              {ACCESS_COMPETENCIES[this.props.userdata.companyID] &&
                this.props.userdata.userType !== 21 && (
                  <StyledMenuItem
                    component={Link}
                    to="/competencies"
                    variant="contained"
                  >
                    <ListItemIcon>
                      <AccountBalanceIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                      {VALUES_NAME[`${this.props.userdata.companyID}`]
                        ? VALUES_NAME[`${this.props.userdata.companyID}`]
                        : VALUES_NAME.other}
                    </ListItemText>
                  </StyledMenuItem>
                )}

            {/* {ACCESS_COMPETENCIES[this.props.userdata.companyID] ?
              <StyledMenuItem
                component={Link}
                to={`/competencies`}
                variant='contained'
              >
                <ListItemIcon>
                  <AccountBalanceIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText>
                  {VALUES_NAME[`${this.props.userdata.companyID}`]
                    ? VALUES_NAME[`${this.props.userdata.companyID}`]
                    : VALUES_NAME.other}
                </ListItemText>
              </StyledMenuItem>
              : null} */}

            {(this.props.userdata.userType === 7 || this.props.userdata.userType === '7')
              && allowedUids.includes(userdata.uid)
            ?

            <div>
              <StyledMenuItem
                component={Link}
                to={`/MEVSettings`}
                variant='contained'
              >
                <ListItemIcon>
                  <AccountBalanceIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText primary='MEV settings' />
              </StyledMenuItem>

              <StyledMenuItem
                component={Link}
                to={`/cosign`}
                variant='contained'
              >
                <ListItemIcon>
                  <AccountBalanceIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText primary='Co-sign' />
              </StyledMenuItem>  
  
                <StyledMenuItem
                component={Link}
                to={`/monitor`}
                variant='contained'
              >
                <ListItemIcon>
                  <AccountBalanceIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText primary='Monitor' />
              </StyledMenuItem>      
    
          <StyledMenuItem 
                component={Link}
                to={`/WebSourceSettings`} 
                variant='contained'>
            <ListItemIcon>
              <LanguageIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary='Web sources' />
          </StyledMenuItem>

              <StyledMenuItem
                component={Link}
                to={`/fixcompany`}
                variant='contained'
              >
                <ListItemIcon>
                  <AccountBalanceIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText primary='fixcompany' />
              </StyledMenuItem>  
              </div>           
              : null}

          </StyledMenu>

        </div>

        {/* <div>
       { this.state.uploading ?
        <div style={{
          width:'100%',
          height: '20px'
          }}><LeaderLoader /></div>
         :null}
         </div> */}

      {this.props.userdata.userType === 21 ? null :
        <div className={classes.root}>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            {tableData.length > 0 ? (
              <MUIDataTable
                title={'Patrons & Members'}
                data={tableData}
                columns={getColumnsWithVisibility()}
                options={mergedOptions}
                {...this.props}
              />
            ) : null}
          </MuiThemeProvider>
        </div>
      }
        <GroupAdminDialog
          open={this.state.openGroupAdminDialog}
          closeGroupAdminDialog={this.handleCloseGroupAdminDialog}
          columns={this.columns}
          users={this.formatUserList(this.transformTableData())}
        />

        <GroupEditAdminDialog
          open={this.state.openGroupEditAdminDialog}
          closeGroupAdminDialog={this.handleCloseGroupEditAdminDialog}
          columns={this.columns}
          users={this.formatUserList(this.transformTableData())}
        />

        <AddCorpUserDialog
          open={this.state.openDialog}
          edit={this.state.edit}
          editedUser={this.state.editedUser}
          onSubmitUserClick={this.handleSubmitUser}
          updateOnSave={this.state.openUpdateDialog}
          onOpenAddUserDialog={this.handleCloseDialog}
          userdata={this.props.userdata}
          //lcpool={this.getLCPOOLValue}
          lcpool={this.state.LCPOOLValue}
        />

        <UserTypeDialog
          open={this.state.openUserType}
          onSubmitSelectedUserType={this.handleSelectedUserType}
          selectedUserType={this.state.selectedUserType}
          onOpenUserTypeDialog={this.handleUserTypeDialog}
          userdata={this.props.userdata}
        />
        <ChangeUserPasswordDialog
          onOpenChangePassword={this.handleOpenChangePassword}
          open={this.state.openPasswordChange}
        />
      </Paper>
    )
  }
}
const CompanyAdminStyled = withStyles(styles)(CompanyAdmin)

const mapStateToProps = (state, ownProps) => {
  return {
    userdata: state.userDialog.userDetails[0],
    users: state.users.users,
    user_exists: state.users.userexists,
    showprogress: state.loader.showloader,
    simplething: state.simpleVal.simplething
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getAllCompanyUsers,
    getAllCompanySettings,
    getAllGeneralSettings,
    deleteCompanyUser,
    resetYCompanyUser,
    createCompanyUser,
    checkUserExists,
    checkUserExistsEdit,
    resendWelcomeEmail,
    updateCompanyUser,
    changeUserType,
    showLoader,
    showToast,
    hideLoader,
    editUser,
    simpleAction
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAdminStyled)
